import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { effectiveRole } from "./roles";
import { PhoneInput } from "../misc/PhoneInput";
import { HelpHint } from "../misc/HelpHint";
import { email, required, useGetIdentity, useRecordContext } from "ra-core";

import { BooleanInput } from "@/components/admin/boolean-input";
import { SelectInput } from "@/components/admin/select-input";
import { salesRoleChoices } from "./roles";
import { TextInput } from "@/components/admin/text-input";

import type { Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const { setValue } = useFormContext();
  const initialRole = effectiveRole(record);
  const initialAdmin = !!record?.administrator;
  useEffect(() => {
    if (initialAdmin) setValue("role", initialRole, { shouldDirty: false });
  }, [record?.id, initialAdmin, initialRole, setValue]);

  return (
    <div className="space-y-4 w-full">
      <TextInput
        source="first_name"
        label="Имя"
        validate={required()}
        helperText={false}
      />

      <TextInput
        source="last_name"
        label="Фамилия"
        validate={required()}
        helperText={false}
      />

      <TextInput
        source="email"
        label="Email"
        validate={[required(), email()]}
        helperText={false}
      />

      <PhoneInput source="phone" label="Телефон" helperText={false} />

      <HelpHint>
        Роль определяет доступные разделы и рабочую область. Руководитель и
        админ имеют полный доступ.
      </HelpHint>
      <SelectInput
        source="role"
        label="Роль"
        choices={salesRoleChoices}
        defaultValue="junior_manager"
        validate={required()}
        translateChoice={false}
        helperText={false}
      />

      {identity?.administrator && (
        <div className="space-y-2">
          <BooleanInput
            source="hidden_from_team"
            label="Скрыть от команды"
            defaultValue={false}
            helperText={false}
          />
          <p className="text-sm text-muted-foreground">
            Видим только администраторам. Сотрудникам недоступны его профиль,
            задачи, комментарии и события в ленте.
          </p>
        </div>
      )}

      <BooleanInput
        source="disabled"
        label="Отключён"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
    </div>
  );
}
